import { MDBRow} from "mdbreact";
import React from "react";
import IconOne from "../../../../new_images/Landing/Icons/Icon_n1.png";
import IconTwo from "../../../../new_images/Landing/Icons/Icon_n2.png";
import IconThree from "../../../../new_images/Landing/Icons/Icon_n3.png";
import IconFour from "../../../../new_images/Landing/Icons/Icon_n4.png";
import "./HowUse.css"


class Disfruta extends React.Component {
  render() {
    return (
      <section className="text-left my-5">
      <p
        className="p_titulo mb-3"
      >
        ¿Cómo usar Tovo siendo conductor?
      </p>

      <div style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "10px"
                }}>
        <div className="view-DisfrutaPasajero col-lg-11" >
          <MDBRow>
            <MDBRow around style={{width:"100%"}}>
              <div className="col-lg-2" >
                <div className="img_num">
                <img src={IconOne} height="70px" alt="servicio de calidad" style={{marginTop: "10px", marginBottom: "10px"}} /> 
              </div>
              </div>
              <div className="col-lg-3" >
                <p className="p_title">Instala la app y regístrate</p>
              </div>
              <div className="col-lg-5" >
                <p className="p_texto">Descarga la app, registra tu información de perfil y sube la documentación solicitada, espera la verificación y ¡comienza!</p>
              </div>
            </MDBRow>
            <MDBRow around style={{width:"100%"}}>
              <div className="col-lg-2" >
                <div className="img_num">
                <img src={IconTwo} height="70px" alt="servicio de calidad" style={{marginTop: "10px", marginBottom: "10px"}} /> 
              </div>
              </div>
              <div className="col-lg-3" >
                <p className="p_title">Programa tus viajes</p>
              </div>
              <div className="col-lg-5" >
                <p className="p_texto">Crea tu viaje, define la ruta y horario, configura tus preferencias y listo! ya puedes publicar tu viaje.</p>
              </div>
            </MDBRow>
            <MDBRow around style={{width:"100%"}}>
              <div className="col-lg-2" >
                <div className="img_num">
                <img src={IconThree} height="70px" alt="servicio de calidad" style={{marginTop: "10px", marginBottom: "10px"}} /> 
              </div>
              </div>
              <div className="col-lg-3" >
                <p className="p_title">Recibe solicitudes de reserva</p>
              </div>
              <div className="col-lg-5" >
                <p className="p_texto">Tovo te conecta con la comunidad de pasajeros, los cuales revisan tus viajes y te envian solicitudes de reserva.</p>
              </div>
            </MDBRow>
            <MDBRow around style={{width:"100%"}}>
              <div className="col-lg-2" >
                <div className="img_num">
                <img src={IconFour} height="70px" alt="servicio de calidad" style={{marginTop: "10px", marginBottom: "10px"}} /> 
              </div>
              </div>
              <div className="col-lg-3" >
                <p className="p_title">¡Qué empiece el viaje!</p>
              </div>
              <div className="col-lg-5" >
                <p className="p_texto">Recoge a los pasajeros que hayas aceptado y bríndales un servicio cómodo y seguro.</p>
              </div>
            </MDBRow>
          </MDBRow>   
        </div>
      </div>
    </section>
    );
  }
}

export default Disfruta;
